import "@/App.css";
import "@/admin.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Weekend from "@/pages/Weekend";
import GuestInvite from "@/components/GuestInvite";
import { GUEST_INVITES } from "@/inviteList";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/ourweddingweekend" element={<Weekend />} />
          <Route path="/OurWeddingWeekend" element={<Weekend />} />
          <Route path="/weekend" element={<Weekend />} />
          {GUEST_INVITES.flatMap((g) =>
            g.paths.map((p) => (
              <Route
                key={p}
                path={p}
                element={<GuestInvite src={g.src} title={g.title} slug={g.slug} />}
              />
            ))
          )}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
